import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';
const withAuth = () => ({
    headers: { Authorization: `Bearer ${getToken()}` },
    withCredentials: true,
})

export const getBranchExpenses = async (branchId, startDate, endDate, params = {}) =>
    (await axios.get(`${API_URL}/branch/${branchId}/branch-expense`, {
        ...withAuth(),
        params: { startDate, endDate, ...params },
    })).data;

export const createBranchExpense = async (branchId, data) =>
    (await axios.post(`${API_URL}/branch/${branchId}/branch-expense`, data, withAuth())).data;

export const updateBranchExpense = async (branchId, id, data) =>
    (await axios.patch(`${API_URL}/branch/${branchId}/branch-expense/${id}`, data, withAuth())).data;

export const deleteBranchExpense = async (branchId, id) =>
    (await axios.delete(`${API_URL}/branch/${branchId}/branch-expense/${id}`, withAuth())).data;
